<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div>
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click=";(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="40%">
            <v-card>
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogAdd = false), clearData()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col cols="11" class="v-margit_text_add">
                        <v-row>
                          <v-col class="text-center">
                            <v-img
                              class="v_text_add"
                              :src="require('@/assets/Grouptitle.svg')"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-img
                              aspect-ratio="6"
                              contain
                              :src="formAdd.pictureUrlPreview"
                              v-if="formAdd.pictureUrlPreview"
                            ></v-img>
                            <br />
                            <v-file-input
                              required
                              counter
                              show-size
                              :rules="[rules.required]"
                              accept="image/png, image/jpeg, image/bmp"
                              prepend-icon="mdi-camera"
                              label="Image"
                              @change="selectImg"
                              v-model="filesAdd"
                            ></v-file-input>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-row style="height: 65px">
                              <v-text-field
                                v-model="formAdd.packageName"
                                label="ชื่อแพคเกจ"
                                outlined
                                dense
                                required
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-row style="height: 65px">
                              <VuetifyMoney
                                v-model="formAdd.packageCount"
                                label="จำนวนครั้งที่ใช้ได้"
                                dense
                                outlined
                                required
                                :rules="[rules.required]"
                                v-bind:options="options2"
                              />
                            </v-row>
                          </v-col>
                          <v-col cols="6">
                            <v-row style="height: 65px">
                              <VuetifyMoney
                                v-model="formAdd.packagePrice"
                                label="ราคาแพคเกจ"
                                outlined
                                dense
                                required
                                :rules="[rules.required]"
                                v-bind:options="options2"
                              />
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-row style="height: 65px">
                              <VuetifyMoney
                                v-model="formAdd.packagePoint"
                                label="คะแนนที่ได้ในแต่ละครั้ง"
                                outlined
                                dense
                                v-bind:options="options2"
                              />
                            </v-row>
                          </v-col>
                          <v-col cols="6">
                            <v-row style="height: 65px">
                              <v-select
                                v-model="formAdd.packageExpri"
                                :items="itemExpri"
                                label="วันหมดอายุของแพคเกจ"
                                outlined
                                dense
                                :rules="[rules.required]"
                              ></v-select>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <!-- <v-col cols="6">
                          <v-row style="height: 65px">
                            <v-select
                              v-model="formAdd.masBranchID"
                              :items="dataBranch"
                              label="สาขา"
                              dense
                              outlined
                              :rules="[rules.required]"
                            ></v-select>
                          </v-row>
                        </v-col> -->
                          <v-col cols="6" v-if="itemLinked.length > 0">
                            <v-row style="height: 65px">
                              <v-select
                                v-model="formAdd.flowId"
                                :items="itemLinked"
                                label="ประเภทบริการ"
                                outlined
                                dense
                              ></v-select>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              v-model="formAdd.packageDetail"
                              outlined
                              name="input-7-4"
                              label="รายละเอียดของแพคเกจ"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <br />
                        <v-col>
                          <v-row justify="center">
                            <v-btn
                              elevation="2"
                              x-large
                              dark
                              color="#173053"
                              :disabled="!validAdd"
                              :loading="loadingAdd"
                              @click="addData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              เพิ่ม
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="40%">
            <v-card>
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-col class="text-right">
                    <v-btn
                      small
                      color="#E0E0E0"
                      @click=";(dialogEdit = false), clearDataUpdate()"
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row justify="center">
                    <v-col cols="11" class="v-margit_text_add">
                      <v-col class="text-center">
                        <v-img
                          class="v_text_edit"
                          :src="require('@/assets/GroupEditTitle.svg')"
                        ></v-img>
                      </v-col>
                      <v-row justify="center">
                        <v-col cols="12" class="text-center">
                          <v-img
                            aspect-ratio="6"
                            contain
                            :src="formUpdate.pictureUrlPreview"
                          ></v-img>
                          <br />
                          <v-file-input
                            required
                            counter
                            show-size
                            :rules="[rules.resizeImag]"
                            accept="image/png, image/jpeg, image/bmp"
                            prepend-icon="mdi-camera"
                            label="Image"
                            @change="selectImgUpdate"
                            v-model="filesUpdate"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-row style="height: 65px">
                            <v-text-field
                              v-model="formUpdate.packageName"
                              label="ชื่อแพคเกจ"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-row style="height: 65px">
                            <VuetifyMoney
                              v-model="formUpdate.packageCount"
                              label="จำนวนครั้งที่ใช้ได้"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                              v-bind:options="options2"
                            />
                          </v-row>
                        </v-col>
                        <v-col cols="6">
                          <v-row style="height: 65px">
                            <VuetifyMoney
                              v-model="formUpdate.packagePrice"
                              label="ราคาแพคเกจ"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                              v-bind:options="options2"
                            />
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-row style="height: 65px">
                            <VuetifyMoney
                              v-model="formUpdate.packagePoint"
                              label="คะแนนที่ได้ในแต่ละครั้ง"
                              outlined
                              dense
                              v-bind:options="options2"
                            />
                          </v-row>
                        </v-col>
                        <v-col cols="6">
                          <v-row style="height: 65px">
                            <v-select
                              v-model="formUpdate.packageExpri"
                              :items="itemExpri"
                              label="วันหมดอายุของแพคเกจ"
                              outlined
                              dense
                              :rules="[rules.required]"
                            ></v-select>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <!-- <v-col cols="6">
                          <v-row style="height: 65px">
                            <v-select
                              v-model="formUpdate.masBranchID"
                              :items="dataBranch"
                              label="สาขา"
                              dense
                              outlined
                              :rules="[rules.required]"
                            ></v-select>
                          </v-row>
                        </v-col> -->
                        <v-col cols="6" v-if="itemLinked.length > 0">
                          <v-row style="height: 65px">
                            <v-select
                              v-model="formUpdate.flowId"
                              :items="itemLinked"
                              label="ประเภทบริการ"
                              outlined
                              dense
                            ></v-select>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-textarea
                            v-model="formUpdate.packageDetail"
                            outlined
                            name="input-7-4"
                            label="รายละเอียดของแพคเกจ"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-col>
                        <v-row justify="center">
                          <v-btn
                            elevation="2"
                            x-large
                            dark
                            color="#173053"
                            :disabled="!validUpdate"
                            :loading="loadingEdit"
                            @click="editData()"
                          >
                            <v-icon left>mdi-checkbox-marked-circle</v-icon>
                            แก้ไขข้อมูล
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="40%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        label="ชื่อแพคเกจ"
                        outlined
                        dense
                        v-model="formUpdate.packageName"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="formUpdate.packageCount"
                        label="จำนวน"
                        dense
                        outlined
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  dark
                  x-large
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  dark
                  x-large
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.packagePrice`]="{ item }">
                    {{ formatNumber(item.packagePrice) }}
                  </template>
                  <template v-slot:[`item.packageExpri`]="{ item }">
                    {{ item.packageExpri }}
                  </template>
                  <template v-slot:[`item.packageImg`]="{ item }">
                    <v-avatar color="primary" size="40">
                      <img :src="item.packageImg" alt="img"
                    /></v-avatar>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          x-small
                          @click.stop="getDataById(item, 'edit'), get"
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          x-small
                          @click.stop="getDataById(item, 'delete')"
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import { VueEditor } from 'vue2-editor'
import VuetifyMoney from '../VuetifyMoney.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VueEditor,
    VuetifyMoney
  },
  data () {
    return {
      PK: '',
      path: '/package/', // Path Model
      returnLink: '/Master/Package',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'จัดการแพคเกจ',
          disabled: false,
          href: '/Master/Package'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      // Dialog Config ADD EDIT DELETE IMPORT
      menu1: false,
      menu2: false,
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      filesAdd: null,
      filesUpdate: null,
      nowDate: new Date().toISOString().slice(0, 10),
      formAdd: {
        packageImg: '',
        packageName: '',
        packageCount: '',
        packagePrice: '',
        packagePoint: '',
        packageExpri: '',
        packageDetail: '',
        flowId: '',
        CREATE_USER: '',
        LAST_USER: '',
        // pictureUrlPreview: '',
        shopId: this.$session.getAll().data.shopId
      },
      formUpdate: {
        packageId: '',
        packageImg: '',
        packageName: '',
        packageCount: '',
        packagePrice: '',
        packagePoint: '',
        packageExpri: '',
        packageDetail: '',
        flowId: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrlPreview: '',
        shopId: ''
      },
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },

      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'รูป', value: 'packageImg' },
        { text: 'ชื่อแพคเกจ', value: 'packageName' },
        { text: 'จำนวนครั้งที่ใช้ได้', value: 'packageCount' },
        { text: 'ราคาแพคเกจ', value: 'packagePrice' },
        { text: 'คะแนนที่ได้ในแต่ละครั้ง', value: 'packagePoint' },
        { text: 'รายละเอียดของแพคเกจ', value: 'packageDetail' },
        { text: 'วันหมดอายุของแพคเกจ', value: 'packageExpridate' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      itemExpri: [
        { text: '3 เดือน', value: '3' },
        { text: '6 เดือน', value: '6' },
        { text: '9 เดือน', value: '9' },
        { text: '1 ปี', value: '12' }
      ],
      dataItem: [],
      validAdd: true,
      validUpdate: true,
      dataLevel: [],
      ProductExchangeRate: [],
      // End Data Table Config
      dataBranch: [],
      itemLinked: [],
      loadingAdd: false,
      loadingEdit: false
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    this.getFlowLinked()
    this.getData()
    this.getProductExchangeRate()
    this.getDataBranch()
  },
  methods: {
    getFlowLinked () {
      axios
        .get(
          'https://api-belinked.betaskthai.com/flow/get?shopId=' +
            // 'Ucb91b5fb61ff0c01e6d7d4c5f7962c57'
            //   +
            this.session.data.shopId
          //     http://localhost:8081/ConditionFlow?shopId=Ucb91b5fb61ff0c01e6d7d4c5f7962c57&flowId=45
        )
        .then(response => {
          let rs = response.data
          rs.map(el =>
            this.itemLinked.push({
              value: el.flowId.toString(),
              text: el.flowName
            })
          )
        })
    },
    getData () {
      console.log(this.dataItem)
      let month = this.dataItem
      this.dataItem = []
      for (let i = 0; i < month.length; i++) {
        let d = month[i]
        if (d.packageExpri !== '') {
          if (d.packageExpri === '12') {
            d.packageExpridate = '1 ปี'
            this.dataItem.push(d)
          } else {
            d.packageExpridate = d.packageExpri + ' เดือน'
            this.dataItem.push(d)
          }
        } else {
          d.packageExpridate = ''
          this.dataItem.push(d)
        }
      }
    },
    selectImgUpdate () {
      if (this.filesUpdate) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    selectImg () {
      if (this.filesAdd) {
        this.formAdd.pictureUrlPreview = URL.createObjectURL(this.filesAdd)
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getDataById (item, type) {
      this.dataReady = true
      Object.assign(this.formUpdate, item)
      this.formUpdate.pictureUrlPreview = this.formUpdate.packageImg
      if (this.formUpdate.packageExpri === '') {
        this.formUpdate.packageExpri = ''
      } else {
        this.formUpdate.packageExpri = this.formUpdate.packageExpri
      }
      if (this.formUpdate.packageExchange === '') {
        this.formUpdate.packageExchange = ''
      } else {
        this.formUpdate.packageExchange = this.formUpdate.packageExchange
      }
      if (type === 'edit') {
        this.dialogEdit = true
        this.validate('UPDATE')
      } else if (type === 'delete') {
        this.dialogDelete = true
      }
    },
    async getProductExchangeRate () {
      this.ProductExchangeRate = []
      await axios
        .get(
          this.DNS_IP +
            '/productExchangeRate/' +
            'get?shopId=' +
            this.session.data.shopId
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.productExchangeRateId.toString()
            s.text = d.name
            d = s
            console.log(d)
            this.ProductExchangeRate.push(d)
          }
          console.log('this.ProductExchangeRate : ', this.ProductExchangeRate)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async addData () {
      console.log(this.formAdd)
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          const _this = this
          let params = new FormData()
          params.append('file', this.filesAdd)
          console.log('params', params)

          await axios
            .post(this.DNS_IP + `/file/upload/package`, params)
            .then(function (response) {
              _this.formAdd.packageImg = response.data
              console.log('url Pic', response.data)
            })
          delete this.formAdd['pictureUrlPreview']
          await axios
            .post(this.DNS_IP + this.path + 'add', this.formAdd)
            .then(async response => {
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.dialogAdd = false
              // Load Data
              await this.clearData()
              //   this.filesAdd = null
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              await this.getData()
              this.loadingAdd = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.packageId
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)
            await axios
              .post(this.DNS_IP + `/file/upload/package`, params)
              .then(function (response) {
                _this.formUpdate.packageImg = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.packageImg = this.formUpdate.pictureUrlPreview
          }
          delete this.formUpdate['pictureUrlPreview']
          delete this.formUpdate['packageId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['CREATE_USER']
          delete this.formUpdate['packageExpridate']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'edit/' + ID,
              this.formUpdate
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false
              // Load Data
              // await this.reloadData()
              await this.clearDataUpdate()
              this.filesUpdate = null
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              await this.getData()
              this.loadingEdit = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.packageId)
      this.dataReady = false
      await this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.packageId,
        this.session.data.shopId,
        '',
        this.returnLink
      )
    },
    async clearData () {
      this.formAdd.packageName = ''
      this.formAdd.packageCount = ''
      this.formAdd.packageImg = ''
      this.formAdd.packagePrice = ''
      this.formAdd.packagePoint = ''
      this.formAdd.packageExpri = ''
      this.formAdd.packageDetail = ''
      this.formAdd.flowId = ''
      //   this.formAdd.masBranchID = ''
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.pictureUrlPreview = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
    },
    async clearDataUpdate () {
      this.formUpdate.packageId = ''
      this.formUpdate.packageImg = ''
      this.formUpdate.packageName = ''
      this.formUpdate.packageCount = ''
      this.formUpdate.packagePrice = ''
      this.formUpdate.packagePoint = ''
      this.formUpdate.packageExpri = ''
      this.formUpdate.packageDetail = ''
      this.formUpdate.flowId = ''
      this.formUpdate.masBranchID = ''
      this.formUpdate.CREATE_USER = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.pictureUrlPreview = ''
      this.formUpdate.shopId = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Master/Package.vue